var _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStripeDelimiter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.641602,
    y1: 8.02417,
    x2: 0.641602,
    y2: 3.02417,
    stroke: "#9D9999"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.31982,
    y1: 11.1908,
    x2: 3.31982,
    y2: 8.1908,
    stroke: "#9D9999"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.31982,
    y1: 3.52417,
    x2: 3.31982,
    y2: 0.52417,
    stroke: "#9D9999"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeDelimiter);
export default __webpack_public_path__ + "static/media/stripe-delimiter.38b8cd73158eb539795bcdbe74204a5a.svg";
export { ForwardRef as ReactComponent };